export const SEARCH_DELAY = 200;
export const PARTICIPANT_LIMIT = 20;
